module.exports = __webpack_public_path__ + "static/media/general-de-seguros-provider.3f71b797.svg";